import { render, staticRenderFns } from "./UserRegistrationDialog.vue?vue&type=template&id=3b1c412c&"
import script from "./UserRegistrationDialog.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports